// src/pages/NewHomePage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import './NewHomePage.css';
import TopBanner from '../../components/Banner/TopBanner.js';
import FeaturedProducts from '../../components/FeaturedProducts/FeaturedProducts/FeaturedProducts';
import Banner from '../../components/Banner/Banner';
import CTASection from '../../components/CTA/CTASection/CTASection';
import BrandShowcase from '../../components/BrandShowcase/BrandShowcase';
import NewsletterBanner from '../../components/Banner/NewsletterBanner.js';

const NewHomePage = () => {
  return (
    <div className="new-homepage">
      <Helmet>
        <title>Pharm-Rx: APIs, Nutraceuticals & More</title>
        <meta name="description" content="Providing top-tier pharmaceutical and nutritional ingredients since 1991. Committed to quality, competitive pricing, and unparalleled service." />
        <meta property="og:title" content="Pharm-Rx: APIs, Nutraceuticals & More" />
        <meta property="og:description" content="Providing top-tier pharmaceutical and nutritional ingredients since 1991. Committed to quality, competitive pricing, and unparalleled service." />
        {/* <meta property="og:image" content="URL_of_social_media_image" /> */}
        <meta property="og:url" content="https://www.pharm-rxchem.com/" />
        <meta property="og:site_name" content="Pharm-Rx" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "Pharm-Rx",
            "url": "https://www.pharm-rxchem.com",
            "description": "Providing top-tier pharmaceutical and nutritional ingredients since 1991. Committed to quality, competitive pricing, and unparalleled service.",
          })}
        </script>
      </Helmet>

      <TopBanner />
      <FeaturedProducts />
      <Banner />
      <CTASection />
      <BrandShowcase />
      <NewsletterBanner
        heading="Subscribe to Our Newsletter"
        paragraph="Subscribe to our newsletter for exclusive updates on events, new products, and industry insights."
      />
    </div>
  );
};

export default NewHomePage;
